import { render, staticRenderFns } from "./sourcesOfEdibleWaste.vue?vue&type=template&id=788cd8bd"
import script from "./sourcesOfEdibleWaste.js?vue&type=script&lang=js&external"
export * from "./sourcesOfEdibleWaste.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports